import React, { useCallback } from "react";
import { Clue } from "../models/clue";
import { ClueSpec } from "../ClueSpec";
import "./CrosswordClues.css";
import { GridCellState } from "../GridCellState";
import { clueString } from "../utils/GridUtils";
import { sanitizeClueHtml } from "../utils/sanitizeClue";

interface CrosswordCluesProps {
  clues: Clue[];
  selectedClue: ClueSpec;
  grid: GridCellState[][];
  onClueChange: (clueSpec: ClueSpec) => void;
  loading: boolean;
}

const CrosswordClues: React.FC<CrosswordCluesProps> = ({
  clues,
  selectedClue,
  grid,
  onClueChange,
  loading,
}) => {
  const acrossClues = clues.filter((clue) => clue.isAcross);
  const downClues = clues.filter((clue) => !clue.isAcross);

  const handleClueClick = useCallback(
    (clue: Clue) => {
      const direction = clue.isAcross ? "across" : "down";
      const spec = new ClueSpec(clue.clueNumber, direction, clue.row, clue.column);
      onClueChange(spec);
    },
    [onClueChange]
  );

  const isClueDone = useCallback(
    (clue: Clue): boolean => {
      if (!grid || !grid[0]) {
        return false;
      }
      const rowstep = clue.isAcross ? 0 : 1;
      const colstep = clue.isAcross ? 1 : 0;
      for (let i = 0; i < clue.length; i++) {
        if (grid[clue.row + rowstep * i][clue.column + colstep * i].userText === "") {
          return false;
        }
      }
      return true;
    },
    [grid]
  );

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="crossword-clues">
      <div className="clues-section">
        <div className="across-clues">
          <p className="clue-direction">Across</p>
          <ul>
            {acrossClues.map((clue) => (
              <li
                key={clue.id}
                style={{
                  //color: isClueDone(clue) ? "green" : "black",
                  textDecoration: isClueDone(clue) ? "line-through" : "none",
                  fontWeight:
                    selectedClue?.number === clue.clueNumber && selectedClue?.direction === "across"
                      ? "bold"
                      : "normal",
                }}
                onClick={() => handleClueClick(clue)}
                dangerouslySetInnerHTML={{ __html: sanitizeClueHtml(clueString(clue)) }}
              />
            ))}
          </ul>
        </div>
        <div className="down-clues">
          <p className="clue-direction">Down</p>
          <ul>
            {downClues.map((clue) => (
              <li
                key={clue.id}
                style={{
                  //color: isClueDone(clue) ? "green" : "black",
                  textDecoration: isClueDone(clue) ? "line-through" : "none",
                  fontWeight:
                    selectedClue?.number === clue.clueNumber && selectedClue?.direction === "down"
                      ? "bold"
                      : "normal",
                }}
                onClick={() => handleClueClick(clue)}
                dangerouslySetInnerHTML={{ __html: sanitizeClueHtml(clueString(clue)) }}
              />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default CrosswordClues;
